'use client';

import { SessionProvider } from 'next-auth/react';

import { AuthProvider } from './auth-context';

// A simple wrapper so we can use <SessionProvider> in a client component.
export function NextAuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <AuthProvider>{children}</AuthProvider>
    </SessionProvider>
  );
}
